<div class="rotator">
  @for (image of images; track image.src; let i = $index) {
  <img class="rotator__img" [class.is-active]="i === activeIndex" [src]="image.src" [alt]="image.alt" />
  } @if (images.length > 1) {
  <div class="rotator__indicator">{{ activeIndex + 1 }} / {{ images.length }}</div>
  }
</div>
